/**
 * @author NikolaV
 */

import { Ajax } from '@shared/Ajax';
import { FilesDownloadDialog } from '@shared/files/FilesDownloadDialog';
import { Notify } from '@shared/ui-native/Notify';
import { WebviewInterface } from '@shared/WebviewInterface';


function fetch(): JQueryPromise<{
    idocuments: IDocument[]
}> {
    return Ajax({
        url: `ajax_map_documents_in_project.json`,
        data: {
            id: 0
        },
    }).then(r => {
        r.idocuments?.forEach(d => {
            d.folderUuid = d.folder?.uuid;
        });
        r.edocuments.forEach(d => {
            r.idocuments.push({
                ...d,
                timestamp: d.created,
                folder: {
                    id: d.folderId,
                    uuid: d.folderUuid,
                }
            })
        });
        return r;
    });
}


function bulkSave(formData): JQueryPromise<any> {
    return Ajax({
        url: 'documents_bulk_edit.json',
        method: 'POST',
        data: formData,
    });
}

function remove(documentIds: number[], externalIds: number[]): JQueryPromise<any> {
    return Ajax({
        url: 'documents_bulk_delete.json',
        method: 'POST',
        data: {
            documentIds,
            externalIds
        },
    });
}

function download(documentIds: number[], name: string): JQueryPromise<any> {
    if (!kuura.hasPrivilege('Download_Model')) {
        Notify.warn(__('general.validation.access_not_allowed'));
        return;
    }

    if (documentIds && documentIds.length == 1) {
        const fullPath = kuura.getContextPath() + `/api/1/file/${documentIds[0]}/get`;
        if (WebviewInterface.hasAndroidInterface()) {
            WebviewInterface.downloadDocument(documentIds[0], fullPath, name);
        } else {
            window.location.href = location.origin + fullPath;
            return $.Deferred().resolve();
        }
    } else {
        // Queue zipping files and show dialog
        const promise = getDownloadUuid(documentIds);
        promise.done(({uuid}) => FilesDownloadDialog.open({
            uuid
        })).fail(err => {
            if (Array.isArray(err?.errorMessages)) {
                Notify.error(err?.errorMessages[0]);
            }
        });
        return promise;
    }
}

function getDownloadUuid(ids: number[]): JQueryPromise<{
    uuid: string
}> {
    return Ajax({
        url: 'api/1/zip/queue_files',
        method: 'POST',
        data: {
            ids
        }
    });
}

function openInNewTab(id: number, name: string): void {
    const fullPath = kuura.getContextPath() + '/api/1/file/' + id + '/get?inline=true';
    if (WebviewInterface.hasAndroidInterface()) {
        WebviewInterface.displayDocument(id, fullPath, name);
    } else {
        window.open(fullPath, '_blank');
    }
}

export const DocumentsService = {
    fetch,
    remove,
    download,
    bulkSave,
    openInNewTab
};
